module.exports = __webpack_public_path__ + "media/CN_001.2ededd3b.mp3";